<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div class="columns" :class="!introductionContent.length ? 'column12 align-center' : 'column6'">
					<div class="title-reverse-wrapper">
						<h1>{{ title }}</h1>
						<h2 class="subtitle" :class="!subtitle.length && 'no-after'">{{ subtitle }}</h2>
					</div>
				</div>
				<div class="columns column6">
					<div v-if="introductionContent.length" v-parse-links v-html="introductionContent" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
	<section v-if="content.length" class="main-content background-light">
		<div class="row justify-left">
			<div class="columns column7">
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</section>
	<slot />
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	introductionContent: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row {
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: center;

	.align-center h1,
	.align-center h2 {
		margin-left: auto;
		margin-right: auto;
	}
}

.intro {
	p,
	:deep(p) {
		letter-spacing: 1px;
		font-size: calc(var(--body-font-size) + 1px);
	}
}
</style>
